import { render, staticRenderFns } from "./FontSelector.vue?vue&type=template&id=05604448&scoped=true"
import script from "./FontSelector.vue?vue&type=script&lang=js"
export * from "./FontSelector.vue?vue&type=script&lang=js"
import style0 from "./FontSelector.vue?vue&type=style&index=0&id=05604448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05604448",
  null
  
)

export default component.exports